let _  = {
  debounce: require('lodash/debounce')
}

window.RoutePoint = class {
  static get GOOGLE_PROXY_URL() {
    return document.documentElement.dataset.googleProxyUrl
  }
  static get MIN_LENGTH_VALUE() { return 1 }

  constructor (key, positionOnly, skipMemorize) {
    this.key = key
    this.positionOnly = positionOnly
    this.skipMemorize = skipMemorize
    this.$pointInput = $(`#point${key}`)

    // positionOnly is for static map
    if (this.positionOnly) return

    this.$textInput = $(`#${key}`)
    this.$placeInput = $(`#place${key}`)
    this.country = ''

    if (!this.$textInput.val()) {
      this.remember('place_id', this.$placeInput)
    }

    if (this.$placeInput.val()) {
      this.getPlaceDetails(this.$placeInput.val())
    } else if (this.$textInput.val()) {
      window.queue.afterMapsLoaded(() => this.geocodeAddress());
    }

    this.$textInput.siblings('.button-input-clear').on('click', () => {
      this.clear()
      this.$textInput.focus()
    })
    this.$textInput.siblings('span.icon-direction').on('click', () => {
      this.setCurrentUserLocation()
    })

    this.$textInput.one('focus', () => {
      this.initAutoComplete()
      this.$textInput.focus()
    })

    // can be overrided
    this.updatedPosition = function (pos) {
      console.log('point position updated', pos)
    }
  }

  get text () {
    return this.$textInput.val()
  }

  set text (newValue) {
    this.$textInput.val(newValue).trigger('change').trigger('input')
  }

  get place_id () {
    return this.$placeInput.val()
  }

  set place_id (newValue) {
    this.$placeInput.val(newValue)
    this.memorize('place_id', newValue)
    this.getPlaceDetails(newValue)
  }

  get position() {
    if (!this.positionPoint) return null
    let parsed = this.positionPoint.replace(/\(|\)/g, '')
    return parsed ? parsed.split(',').map(c => parseFloat(c)) : null
  }

  get positionPoint() {
    return this.$pointInput.val()
  }

  set position(newValue) {
    this.$pointInput.val(`(${newValue[0]},${newValue[1]})`)
    // Reverse geocoding still uses the Google SDK; skip it when unavailable
    // (2GIS migration — address auto-fill on drag is handled in phase 2).
    if (typeof google === 'undefined' || !google.maps) return
    let location = { lat: newValue[0], lng: newValue[1] }
    let geocoder = new google.maps.Geocoder()
    geocoder.geocode({ location: location }, (results, status) => {
      if (status !== google.maps.GeocoderStatus.OK) return
      this.skipPointUpdating = true
      this.$textInput.val(results[0].formatted_address)
      this.place_id = results[0].place_id
    })
  }

  clear () {
    this.forget()
    this.$pointInput.val('')
    this.$placeInput.val('')
    this.text = ''
    this.country = ''
    this.updatedPosition(this.position)
  }

  initAutoComplete () {
    let hideGoogleLogo = this.$textInput.data('hideGoogleLogo')
    let isPointSelected = false
    let icons = {
      airport: 'flight',
      train_station: 'train',
      bus_station: 'bus',
      lodging: 'lodging'
    }

    this.$textInput.typeahead(
      {
        minLength: RoutePoint.MIN_LENGTH_VALUE,
        highlight: true,
        hint: false
      },
      {
        name: 'address-lookup',
        async: true,
        source: _.debounce((input, _syncResults, callback) => {
          $.ajax({
            method: 'GET',
            url: RoutePoint.GOOGLE_PROXY_URL + '/address-lookup',
            data: { query: input, lang: document.documentElement.lang }
          }).then(({ status, predictions }) => {
            callback(status === 'OK' ? predictions : [])
            if (!this.$textInput.is(':focus')) {
              this.$textInput.trigger('focusout')
            }
            if (status !== 'OK') {
              this.$textInput
                .parent()
                .find('.icon-spinner')
                .closest('.autocomplete-item')
                .remove()
            }
          })
        }, 500),
        display ({ description }) {
          return description
        },
        templates: {
          pending () {
            return `
              <div class="autocomplete-item text-center">
                <i class="icon-spinner animate-spin"></i>
              </div>
            `
          },
          suggestion ({ description, types }) {
            let locationIcon = 'location'
            for (const type in types) {
              const icon = types[type]
              if (icons[icon]) {
                locationIcon = icons[icon]
                break
              }
            }

            return `
              <div class="autocomplete-item">
                <i class="icon icon-${locationIcon}"></i>
                ${description}
              </div>
            `
          },
          footer () {
            if (hideGoogleLogo) return

            return `
              <div class="powered-by-google">
                <img src="/img/powered-by-google-on-white.png">
              </div>
            `
          }
        }
      }
    ).bind('typeahead:select', (_, { place_id }) => {
      this.place_id = place_id
      isPointSelected = true
    })

    this.$textInput.on('focusout', () => {
      if (this.$textInput.val().length < RoutePoint.MIN_LENGTH_VALUE) {
        isPointSelected = false
        return
      }
      if (isPointSelected) return

      let suggestion = this.$textInput.parent().find('.tt-suggestion')
      if (suggestion.length > 0) {
        if (suggestion.filter('.tt-cursor').length > 0) {
          suggestion.filter('.tt-cursor').click()
        } else {
          suggestion.eq(0).click()
        }
      } else {
        window.queue.afterMapsLoaded(() => this.geocodeAddress());
      }
    })
  }

  getPlaceDetails (place_id) {
    $.ajax({
      method: 'GET',
      url: RoutePoint.GOOGLE_PROXY_URL + '/place',
      data: {
        place_id: place_id,
        lang: document.documentElement.lang
      }
    }).then(({ result }) => {
      const { address_components, location, types, name } = result;
      this.types = types;
      if (!this.text) this.text = name;
      if (this.skipPointUpdating) {
        this.skipPointUpdating = false
      } else {
        this.$pointInput.val(`(${location.lat},${location.lng})`);
      }

      const address = address_components.find(({ types }) => types.includes('country'));
      this.country = address ? address.short_name : '';

      const arr = ['administrative_area_level_2', 'administrative_area_level_1'];
      const area = address_components.find(el => el.types.some(type => arr.includes(type)));
      if (area && address) this.placeFrom = `${area.long_name}, ${address.long_name}`;

      this.updatedPosition(this.position);
    })
  }

  setCurrentUserLocation () {
    let navGeo = navigator.geolocation
    if (!navGeo) return

    navGeo.getCurrentPosition(position => {
      this.position = [position.coords.latitude, position.coords.longitude]
    })
  }

  geocodeAddress () {
    if (typeof google === 'undefined' || !google.maps) return
    let geocoder = new google.maps.Geocoder()
    geocoder.geocode({ address: this.$textInput.val() }, (results, status) => {
      if (status !== google.maps.GeocoderStatus.OK) return
      this.place_id = results[0].place_id
    })
  }

  memorize (type, val) {
    if (!RoutePoint.checkLocalStorage() || this.skipMemorize) return
    if (!val) return localStorage.removeItem(`place_id_${this.key}`)
    localStorage.setItem(`${type}_${this.key}`, val)
  }

  remember (type, input) {
    if (!RoutePoint.checkLocalStorage() || this.skipMemorize) return
    if (input.val()) return
    let val = localStorage.getItem(`${type}_${this.key}`)
    if (val) input.val(val).trigger('change')
  }

  forget () {
    if (!RoutePoint.checkLocalStorage() || this.skipMemorize) return
    localStorage.removeItem(`place_id_${this.key}`)
  }

  static checkLocalStorage () {
    let test = 'test'
    try {
      localStorage.setItem(test, test)
      localStorage.removeItem(test)
      return true
    } catch (_) {
      return false
    }
  }
}
